import { render, staticRenderFns } from "./history-sale.vue?vue&type=template&id=1b73324e&scoped=true&"
import script from "./history-sale.vue?vue&type=script&lang=js&"
export * from "./history-sale.vue?vue&type=script&lang=js&"
import style0 from "./history-sale.vue?vue&type=style&index=0&id=1b73324e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b73324e",
  null
  
)

export default component.exports